import React, { Component } from "react";
import { connect } from "react-redux";

import { DateTimePicker, DatePicker } from 'react-widgets'
import momentLocalizer from 'react-widgets-moment'
import Moment from 'moment'

import debounce from "../../../../utils/debounce";
import { editRow } from "../../../core/actions/editing";
import { DownCaretIcon, PencilIcon } from "../../icons";

Moment.locale('en-GB');
momentLocalizer();


export const EditableCellContent = ({ cellData, field, fieldChoices, inputProperties, fieldType, rowKey,
                                        isDeleted }) => {

    let InputComponent;
    let extraClassName = "register-table--generic-input";

    if ( fieldChoices !== undefined ) {
        // note: if fieldChoices were specified for a boolean field then it will be rendered in this block
        InputComponent = SelectInput;
    }
    else if ( fieldType === "BooleanField" ) {
        InputComponent = SelectInput;
        fieldChoices = [
            [false, 'False'],
            [true, 'True'],
        ];
    }
    else if ( fieldType === 'MemoField' ) {
        InputComponent = MemoInput;
        extraClassName = extraClassName + " register-table--input-focus u-height-100 u-width-100 u-pr--small";
    }
    else if ( fieldType === 'IntegerField' ) {
        InputComponent = IntegerInput;
        extraClassName = extraClassName + " u-height-100 u-width-100";
    }
    else if ( fieldType === 'DateTimeField' ) {
        InputComponent = DateTimeInput;
        extraClassName = "register-table--datetime-input u-height-100";
    }
    else if ( fieldType === 'DateField' ) {
        InputComponent = DateInput;
        extraClassName = "register-table--date-input u-height-100";
    }
    else {
        // default to text input
        InputComponent = TextInput;
        extraClassName = extraClassName + " register-table--input-focus u-height-100 u-width-100 u-pr--small";
    }

    const ConnectedInputComponent = connectToEditState(InputComponent);

    if ( InputComponent === SelectInput ) {
        return <ConnectedInputComponent
            field={ field }
            cellData={ cellData }
            choices={ fieldChoices }
            inputProperties={ inputProperties }
            rowKey={ rowKey }
            extraClassName={ extraClassName }
            isDeleted={ isDeleted }
        />
    }
    return <ConnectedInputComponent
        rowKey={ rowKey }
        field={ field }
        cellData={ cellData }
        inputProperties={ inputProperties }
        extraClassName={ extraClassName }
        isDeleted={ isDeleted }
    />

};


const connectToEditState = (WrappedComponent) => {
    /**
     * HOC that provides a change handler that can update redux state.
     *
     * */
    class EditStateConnectedInputComponent extends Component {
        constructor(props) {
            super(props);
            this.handleChange = this.handleChange.bind(this);
            this.handleChange = debounce(this.handleChange, 250)
        }

        handleChange(value) {
            const {dispatch, rowKey, field} = this.props;
            dispatch( editRow(rowKey, field.name, value) );
        }

        render() {
            return <WrappedComponent handleChange={ this.handleChange } { ...this.props } />
        }

    }
    return connect()(EditStateConnectedInputComponent)
};


const SelectInput = ({ handleChange, cellData, choices, inputProperties, field, extraClassName, isDeleted }) => {
    return (
        <div className={`select-style select-style-registers`}>
            <select className={ extraClassName } defaultValue={ cellData } onBlur={ (e) => handleChange(e.target.value) } disabled={ isDeleted }>
                { choices.map((choice) => {
                    const value = choice[0];
                    const displayValue = choice[1];
                    return (
                        <option
                            key={ field.name + '.' + value }
                            value={ value }
                        >{ displayValue }</option>
                    )
                })}
            </select>
            <DownCaretIcon />
        </div>
    );
};

const TextInput = ({ handleChange, cellData, inputProperties, extraClassName, isDeleted }) => {
    const maxLength = inputProperties.max_length;
    return (
        <div className={`u-pos-relative u-height-100`}>
            <input className={ extraClassName } type="text" maxLength={ maxLength } defaultValue={ cellData }
                   onBlur={ (e) => handleChange(e.target.value) } disabled={ isDeleted } />
            <PencilIcon />
        </div>
    );
};

const MemoInput = ({ handleChange, cellData, inputProperties, extraClassName, isDeleted }) => {
    const maxLength = inputProperties.max_length;
    return (
        <div className={`u-pos-relative u-height-100`}>
            <input className={extraClassName} type="text" maxLength={ maxLength } defaultValue={cellData}
                   onBlur={(e) => handleChange(e.target.value)} disabled={isDeleted}/>
            <PencilIcon/>
        </div>
    )
};


const IntegerInput = ({ handleChange, cellData, inputProperties, extraClassName, isDeleted }) => {
    const minValue = inputProperties.min_value;
    const maxValue = inputProperties.max_value;
    return (
        <div className={`u-pos-relative u-height-100`}>
            <input className={ extraClassName } type="number" defaultValue={ cellData }
                   onBlur={ (e) => handleChange(e.target.value) } disabled={ isDeleted }
                   min={ minValue } max={ maxValue }
            />
        </div>
    );
};

export class DateInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dropUp: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.storageDateFormat = "YYYY-MM-DD";
    }

    handleClick(e) {
        if (e.target.tagName === 'INPUT') {
            this.setState({open: 'date'});
        }
    }

    handleToggle(view) {
        let toggledState = (this.state.open) ? false : view;
        this.setState({open: toggledState});
    }

    componentDidMount() {
        // @todo - there's possibly a better way to handle this via shouldComponentUpdate or some such. -richb
        // this is probably not overly performant as it stands.
        let registerTableBottomPosition = document.getElementById('register-table').getBoundingClientRect().bottom;
        let datePickerComponentBottomPosition = this.datePickerContainer.getBoundingClientRect().bottom;
        if ((registerTableBottomPosition - datePickerComponentBottomPosition) < 300) {
            this.setState({dropUp: true});
        }
    }

    handleInputChange(value) {
        /**
         * Intercepting the date value and formatting it for storage.
         *
         * Date values are stored in ISO format (YYYY-MM-DD) without time or timezone information.
         * The backend expects this format for DateField values.
         *
         */
        const { handleChange } = this.props;

        value = Moment(value, this.storageDateFormat);
        if (value.isValid()) {
            handleChange(value.format(this.storageDateFormat));
        } else {
            handleChange('');
        }

    }

    render() {

        const { isDeleted, extraClassName, cellData } = this.props;
        const { open, dropUp } = this.state;

        let datetime = null;
        if (cellData) {
            datetime = new Date(cellData);
        }

        return (
            <div
                ref={(ref) => this.datePickerContainer = ref}
                className={"u-height-100"}
            >
                <DatePicker
                    disabled={ isDeleted }
                    className={ extraClassName }
                    dropUp={ dropUp }
                    date={ true }
                    open={ open }
                    defaultValue={ datetime }
                    format={"MMM D, YYYY"}
                    onChange={ (value) => { this.handleInputChange(value) }}
                    onToggle={ this.handleToggle }
                    onClick={ this.handleClick }
                />
            </div>
        )
    }
}

export class DateTimeInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dropUp: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.storageDateFormat = "YYYY-MM-DDTHH:mm:ss";
    }

    handleClick(e) {
        if (e.target.tagName === 'INPUT') {
            this.setState({open: 'date'});
        }
    }

    handleToggle(view) {
        let toggledState = (this.state.open) ? false : view;
        this.setState({open: toggledState});
    }

    componentDidMount() {
        // @todo - there's possibly a better way to handle this via shouldComponentUpdate or some such. -richb
        // this is probably not overly performant as it stands.
        let registerTableBottomPosition = document.getElementById('register-table').getBoundingClientRect().bottom;
        let datePickerComponentBottomPosition = this.dateTimePickerContainer.getBoundingClientRect().bottom;
        if ((registerTableBottomPosition - datePickerComponentBottomPosition) < 300) {
            this.setState({dropUp: true});
        }
    }

    handleInputChange(value) {
        /**
         * Intercepting the datetime value to remove TZ info and milliseconds so CRM doesn't get upset.
         *
         * We make an assumption that date time values passed to the frontend are always in the
         * NZ timezone (NZT or DST) and let the backend make the datetime timezone aware again.
         * This will be achieved because naive datetime values get the local timezone attached.
         * For this reason, do not change this storage format to include TZ information.
         *
         */
        const { handleChange } = this.props;

        value = Moment(value, this.storageDateFormat);
        if (value.isValid()) {
            handleChange(value.format(this.storageDateFormat));
        } else {
            handleChange('');
        }

    }

    render() {

        const { isDeleted, extraClassName, cellData } = this.props;
        const { open, dropUp } = this.state;

        let datetime = null;
        if (cellData) {
            datetime = new Date(cellData);
        }

        return (
            <div
                ref={(ref) => this.dateTimePickerContainer = ref}
                className={"u-height-100"}
            >
                <DateTimePicker
                    disabled={ isDeleted }
                    className={ extraClassName }
                    dropUp={ dropUp }
                    date={ true }
                    time={ true }
                    open={ open }
                    defaultValue={ datetime }
                    onChange={ (value) => { this.handleInputChange(value) }}
                    onToggle={ this.handleToggle }
                    onClick={ this.handleClick }
                />
            </div>
        )
    }
}
